module.exports = __webpack_public_path__ + "img/wordcloud-arkadijs-mazjanis.efe3f1b4.png";